export const DOMAINS_SUFFIXES_BY_COLUMNS = [
  ['com', 'org', 'net'],
  ['club', 'info', 'biz'],
  ['online', 'store', 'shop']
];

export const DOMAINS_SUFFIXES_LIST = ['com', 'org', 'net', 'club', 'info', 'biz', 'online', 'store', 'shop'];
